// Componente Icon — wrapper de SVG inline estilo Tabler outline.
// Usa el registry de `icon-paths.tsx`. Stroke por default 1.5, ajustable.
//
//   <Icon name="alert" />                 → 16x16, stroke 1.5
//   <Icon name="chevron-down" size={12} />
//   <Icon name="check" className="text-ok" />
//
// El color sale de `currentColor` (heredado de la clase de texto del padre).

import { ICON_PATHS, type IconName } from './icon-paths';
import { cn } from '../../lib/utils';

interface IconProps {
  name: IconName;
  size?: number;
  stroke?: number;
  className?: string;
}

export function Icon({ name, size = 16, stroke = 1.5, className }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      className={cn('inline-block flex-shrink-0', className)}
    >
      {ICON_PATHS[name]}
    </svg>
  );
}

export type { IconName };
